import React from "react";
import { IonContent, IonFab, IonFabButton, IonPage } from '@ionic/react';
import './ResetPassword.css';
import ReactGA from "react-ga4";

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/ResetPassword',
//       page_title: 'ResetPassword'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });

// ReactGA.send({ hitType: "pageview", page: "/pages/ResetPassword", title: "Restablecer contraseña" });

const ResetPassword: React.FC = () => {

 
    return (
        <IonPage>
            <IonContent>
                <div className="reset-div">
                    <IonFab className="floating" slot="fixed">
                        <IonFabButton onClick={ () => window.location.href = '/'} color="primary">Login</IonFabButton>
                    </IonFab>
                    <iframe src="https://portal.mastinseguridad.com/reset_password" className="reset" frameBorder="0"></iframe>
                </div>
            </IonContent>
        </IonPage>
    );
}

export default ResetPassword;